import { FormulaireSchemaType, QualityEnum, WorkTypeEnum } from '../../validation/formulaire.schema'
import { IFormulaireFranceState, IMusicInfo, IRightHolders, IRole, IMusicType } from '../../../../Store/Formulaire/Types'

function getWorkType(type: WorkTypeEnum): IMusicType {
    switch (type) {
        case WorkTypeEnum.NEW:
            return IMusicType.NEW
        case WorkTypeEnum.EXISTING:
            return IMusicType.EXISTING
        case WorkTypeEnum.SIGNATURE:
            return IMusicType.SIGNATURE
        default:
            return IMusicType.NEW
    }
}

function qualityEnumToRole(quality: QualityEnum): IRole {
    switch (quality) {
        case QualityEnum.ARTIST:
            return IRole.ARTIST
        case QualityEnum.AUTHOR:
            return IRole.AUTHOR
        case QualityEnum.COMPOSER:
            return IRole.COMPOSER
        case QualityEnum.ARRANGER:
            return IRole.ARRANGER
        case QualityEnum.EDITOR:
            return IRole.EDITOR
        default:
            return IRole.ARTIST
    }
}

const zodBeneficiaryToDomain = (beneficiary: { names: string; qualities?: QualityEnum[], beneficiary_id?: string | null }): IRightHolders => ({
    id: beneficiary.beneficiary_id ? parseInt(beneficiary.beneficiary_id) : undefined,
    name: beneficiary.names,
    roles: beneficiary.qualities?.map(qualityEnumToRole) || []
})

const zodMusicToDomain = (music: FormulaireSchemaType['works'][0]): IMusicInfo => ({
    id: music.work_id || undefined,
    title: music.title,
    usage_duration: parseInt(music.usedInSpotDuration),
    type: getWorkType(music.workType),
    code_iswc: music.iswcCode || '',
    code_isrc: music.isrcCode || '',
    code: music.workCode || '',
    right_holders: music?.beneficiaries?.map(zodBeneficiaryToDomain) || [],
    file_name: music.file_name || "",
    audio_file: music.audioFile || undefined
})

function mapZodToDomain(formData: FormulaireSchemaType, originalFormulaire: IFormulaireFranceState): IFormulaireFranceState {
    return {
        ...originalFormulaire,
        marque: formData.spot.brand,
        product_name: formData.spot.productName,
        product_nature: formData.spot.productNature || '',
        agency: formData.spot.declarant || '',
        spot_title: formData.spot.spotTitle,
        duration: parseInt(formData.spot.duration),
        codes_arpp: formData.spot.arppCodes || '',
        codes_pub_id: formData.spot.pubIdCodes || '',
        id_crea_code: formData.spot.idCreaCode || '',
        media: {
            ...originalFormulaire.media,
            type: formData.first_diffusion.media,
        },
        diffuser: formData.first_diffusion.broadcaster,
        diffusion_date: formData.first_diffusion.dateTime,
        music: formData?.works?.map(zodMusicToDomain) || [],
        should_send_to_sacem: formData.should_send_to_sacem || false,
    }
}

export const zodToDomainMapper = {
    mapZodToDomain
}